import config, { endpoints } from '@/config/index';
import { logger } from '@/helpers/logger';
import { useMutation } from 'react-query';
import useFrcCaptcha from '../useFrcCaptcha/useFrcCaptcha';

type JobAlertModalState = {
  email: string;
  timeType: string[];
  categories: string[];
  token?: string;
  apiBaseUrl: string;
};

interface UseSubmitJobAlertProps {
  onSuccess?: (data: Response, variables: JobAlertModalState) => void;
  onError?: (
    error: unknown,
    variables: JobAlertModalState,
    snapshotValue: unknown
  ) => void;
  onMutate?: (variables: JobAlertModalState) => void;
}

export const useSubmitJobAlert = ({
  onSuccess,
  onError,
}: UseSubmitJobAlertProps = {}) => {
  const { getSolution, FrcCaptchaComponent } = useFrcCaptcha();

  const mutationFn = async (state: JobAlertModalState) => {
    const frcCaptchaSolution = await getSolution();

    if (typeof state === 'undefined') {
      logger.error('some data in state are wrong or missing', state);
    }
    // add Datalayer Events...
    return fetch(`${config.api.baseUrl}${endpoints.jobAlertSubscribe}`, {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({
        ...state,
        frcCaptchaSolution,
        apiBaseUrl: config.api.baseUrl,
      }),
    }).then((response) =>
      response.status === 200 ? response : Promise.reject(response)
    );
  };

  const { mutate: sendData, ...mutation } = useMutation(mutationFn, {
    onError,
    onSuccess,
  });

  return {
    sendData,
    FrcCaptchaComponent,
    ...mutation,
  };
};
